import React, { FC } from 'react';
import { History } from 'entities/History/components';
import { VoiceCallWrapper } from 'entities/Calls/components';
import { Notes } from 'entities/Notes/components';
import { IPatient } from 'entities/Patient/Patient.models';
import { EventControls } from 'entities/Events/components';
import { IEvent } from 'entities/Events/Event.models';

interface IComponentProps {
  event: IEvent | null;
  patient: IPatient | null;
}

export const EventSidebar: FC<IComponentProps> = ({ event, patient }) => {
  return (
    <div className="flex-1 event-sidebar">
      <div className="mb-6">
        <EventControls event={event} />
      </div>

      <div className="mb-6">
        <VoiceCallWrapper event={event} />
      </div>

      <div className="mb-6">
        <Notes eventId={event?.id} />
      </div>

      <History eventId={event?.id} patient={patient} />
    </div>
  );
};
